import type { App } from 'vue'
import {
	getLocalStorage,
	setLocalStorage,
	remLocalStorage,
	cleanLocalStorage,
} from '@ipevo-rd/service-web-utils'

export default {
	install(app: App) {
		app.config.globalProperties['$getLocalStorage'] = getLocalStorage
		app.config.globalProperties['$setLocalStorage'] = setLocalStorage
		app.config.globalProperties['$remLocalStorage'] = remLocalStorage
		app.config.globalProperties['$cleanLocalStorage'] = cleanLocalStorage

		app.provide('$getLocalStorage', getLocalStorage)
		app.provide('$setLocalStorage', setLocalStorage)
		app.provide('$remLocalStorage', remLocalStorage)
		app.provide('$cleanLocalStorage', cleanLocalStorage)
	},
}
